<template>
  <v-card-text>
    <v-container>
      <v-row>
        <v-col>
          <v-card color="grey" flat rounded="xl" class="px-12 py-9">
            <v-card-title class="py-6">
              <v-icon size="32" class="mr-4">
                {{ icons.mdiReceiptText }}
              </v-icon>
              <span class="text-body-1 font-weight-bold"> Fatura Bilgileri</span>
            </v-card-title>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Ad Soyad </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.invoiceFullname }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Unvan </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.invoiceCompany }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> VD | VN / TC | Tip </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.invoiceTax }} | {{ callCenterStore.invoiceVat }} |
                  {{ callCenterStore.invoiceType }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Telefon </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.invoicePhone }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> E-Posta </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.invoiceMail }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-item two-line>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Adres </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.data.invoice.invaddr }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ callCenterStore.data.invoice.invaddrcity }} /
                  {{ callCenterStore.data.invoice.invaddrstate }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card-text>
</template>

<script>
// Store
import { useCallCenterStore } from "@/stores/callCenter";
import { mdiReceiptText } from "@mdi/js";
export default {
  setup() {
    const callCenterStore = useCallCenterStore();
    return {
      callCenterStore,
      icons: { mdiReceiptText },
    };
  },
};
</script>

<style></style>
